import { PAGE_LAYOUT, TEXT_STYLES, IMAGES } from '../Constants';

export const PDFFooter = {
  add: function (doc, data) {
    const y = PAGE_LAYOUT.HEIGHT - 14; // 14mm from the bottom

    const logoSize = 16;
    const clientText = data.name ? `Client: ${data.name}` : '';
    const coachText = data.coachName ? `Coach: ${data.coachName}` : '';

    doc.setFont('helvetica', 'italic');
    doc.setFontSize(TEXT_STYLES.SIZES.NORMAL);
    doc.setTextColor(...TEXT_STYLES.COLORS.PRIMARY);

    if (clientText) {
      doc.text(clientText, PAGE_LAYOUT.MARGIN, y, { baseline: "middle" });
    }
    if (coachText) {
      const rightX = PAGE_LAYOUT.WIDTH - PAGE_LAYOUT.MARGIN - doc.getTextWidth(coachText);
      doc.text(coachText, rightX, y, { baseline: "middle" });
    }

    this.addLogoWithLink(doc, y - logoSize / 2, logoSize);
    return y;
  },
  addLogoWithLink: function (doc, y, logoSize) {
    const logoX = (PAGE_LAYOUT.WIDTH / 2) - (logoSize / 2);
    doc.addImage(IMAGES.LOGO, 'PNG', logoX, y, logoSize, logoSize);
    doc.link(logoX, y, logoSize, logoSize, { url: 'https://www.instagram.com/flexcellence.co/' });
  }
};
